import { render, staticRenderFns } from "./SelectDokumenttyp.vue?vue&type=template&id=28925710"
import script from "./SelectDokumenttyp.vue?vue&type=script&lang=js"
export * from "./SelectDokumenttyp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports